import * as React from "react"
import { withRouter, RouteComponentProps } from "react-router-dom"
import PrivacyPolicyComponent from "./components/PrivacyPolicyComponent"

interface IPrivacyPolicyProps extends RouteComponentProps<any> {
}

class PrivacyPolicy extends React.Component<IPrivacyPolicyProps> {
    public render() {
        const { privacyPolicyTextType, certificateType } = this.props.match.params

        return (
            <div>
                <PrivacyPolicyComponent
                    privacyPolicyTextType={+privacyPolicyTextType}
                    certificateType={+certificateType} />
            </div>
        )
    }
}

export default withRouter(PrivacyPolicy)